import { useAppSelector } from 'hooks/reduxHooks'
import { matchPath } from 'react-router-dom'
import { getCanRedeemLuxPlusBenefits, getHasLuxPlusInAnyRegion, getIsEligibleLuxPlusFreePreview, getIsFreePreviewLuxPlusMember } from 'luxPlus/selectors/featureToggle'
import useQueryParams from 'hooks/useQueryParams'
import { LUXURY_PLUS, LUXURY_PLUS_PATHS } from 'luxPlus/constants/base'

/**
 * Determines whether to show the UI to sign up for LuxPlus+ free preview
 */
function useLuxPlusFreePreviewUtils(): {
  showFreePreviewSignup: boolean
  showFreePreviewCarouselSortOrder: boolean
  shouldAutoEnrolFreePreview: boolean
} {
  const freePreviewMember = useAppSelector(getIsFreePreviewLuxPlusMember)
  const freePreviewEligible = useAppSelector(getIsEligibleLuxPlusFreePreview)
  const canRedeemLuxPlusBenefits = useAppSelector(getCanRedeemLuxPlusBenefits)
  const hasPaidLuxPlusMembership = useAppSelector(getHasLuxPlusInAnyRegion)
  const currentPath = useAppSelector(state => state.router.location.pathname)
  const isOnHomepage = !!matchPath({ path: '/:regionCode', end: true }, currentPath)
  const isOnLuxPlusLandingPage = !!matchPath({ path: `/:regionCode/${LUXURY_PLUS_PATHS.DEFAULT_LANDING_PAGE}`, end: true }, currentPath)
  const queryParams = useQueryParams()
  const isFreePreviewParams = queryParams.get(LUXURY_PLUS.FREE_PREVIEW_QUERY_PARAM) === 'true'
  const canJoinFreePreview = !freePreviewMember && !canRedeemLuxPlusBenefits && !hasPaidLuxPlusMembership
  const showFreePreviewCarouselSortOrder = (isFreePreviewParams || freePreviewEligible || freePreviewMember) && !canRedeemLuxPlusBenefits && !hasPaidLuxPlusMembership
  const showFreePreviewSignup = (
    isFreePreviewParams ||
    freePreviewEligible ||
    isOnHomepage ||
    isOnLuxPlusLandingPage
  ) && canJoinFreePreview
  const shouldAutoEnrolFreePreview = queryParams.get(LUXURY_PLUS.FREE_PREVIEW_AUTO_ENROLL_QUERY_PARAM) === 'true' && canJoinFreePreview

  return {
    showFreePreviewSignup,
    showFreePreviewCarouselSortOrder,
    shouldAutoEnrolFreePreview,
  }
}

export default useLuxPlusFreePreviewUtils
